





























import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import SignatureService from "@/services/SignatureService";
import SignersDTO from "@/dto/signature/SignersDTO";
import {processError} from "@/utils/ComponentUtils";
import RouteNames from "@/router/RouteNames";

const AppModule = namespace("App");

@Component
export default class OwnPendingSignatures extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  private signatures: Array<SignersDTO> | [] = [];

  mounted(): void {
    this.loadSignatures();
  }

  loadSignatures(): void {
    this.startLoading();
    SignatureService.getOwnToSign().then(
        response => {
          this.signatures = response.data;
          this.stopLoading();
        },
        error => {
          processError(error, this);
          this.stopLoading();
        }
    );
  }

  goToToSigning(signerId: number): void {
    this.$router.push({name: RouteNames.ARCHIVE_SIGNABLE_OWN, params: {id: `${signerId}`}})
  }

}
